module.exports = {
  generateHeaderMenuLinks(arr) {
    return arr.map((link) => `<a href="${link.href}">${link.label}</a>`).join('');
  },


createElem(elemType, elemOptions, elemText) {
  const newElement = document.createElement(elemType);
  if (elemOptions !== undefined) {
    Object.keys(elemOptions).forEach((attr) => {
      newElement.setAttribute(attr, elemOptions[attr]);
    });
  }
  if (elemText !== undefined) {
    newElement.innerText = elemText;
  }
  return newElement;
  },
  }; 




// WEBPACK FOOTER //
// ./scriptPartials/helperFunctions.js